/*-------------------------------------------------------------------
*  Global Namespacing Utility Function
*
*  $Last Updated: 04-07-2015
------------------------------------------------------------------------*/

(function closure(root, factory) {
	if(typeof define === 'function' && define.amd) {
		define([], function load() {
			return factory(root);
		});
	} else{
		// For non-AMD module, expose this to global (will also be useful for test cases)
		root.THD = factory(root);
	}
})(this, function factory(root) {
	var thd;
	var utils;
	var createNamespace = function createNamespace(nameSpaceString, context) {
		var tokens = nameSpaceString.split('.');
		var current = (context || window);
		var count = tokens.length;
		var token;
		var x;

		for (x = 0; x < count; x++) {
			token = tokens[x];

			if (!current[token]) {
				current[token] = {};
			}

			current = current[token];
		}

		return current;
	};

	if (!root.THD || (root.THD && !root.THD.Global)) {
		/*
			Core Namespace Declaration
		*/
		thd = createNamespace('THD');
		// Global - for THD specific functionality that should be available anywhere on the site
		createNamespace('Global', thd);
		// External - for THD partners
		createNamespace('External', thd);
		// Utility - for general functionality that could be used on any site
		utils = createNamespace('Utility', thd);
		// Widget - Holds implementations for globally usable UI elements
		createNamespace('Widget', thd);
		// PLP Modules (includes Category)
		createNamespace('PLP', thd);
		// PIP Modules
		createNamespace('PIP', thd);
		// Checkout Modules (including Cart)
		createNamespace('Checkout', thd);
		// My Account Modules (includes Calculators)
		createNamespace('MyAccount', thd);
		// Checkout Modules
		createNamespace('Search', thd);
		// Store Finder
		createNamespace('StoreFinder', thd);
		// Analytics
		createNamespace('Analytics', thd);
		/*
			Assign Namespace Utilities
		*/
		// Create Namespace namespace and assign createNamespace. Simple.
		createNamespace('Namespace', utils).createNamespace = createNamespace;
		root.THD = thd;
	}
	return root.THD;
});
